import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Viphamhanhchinh from "components/Quanlyvipham/Hanhchinh/Quanlyvipham.js";
import Viphamgiatsathanhtrinh from "components/Quanlyvipham/Giamsathanhtrinh/Quanlyvipham.js";
export default function DmPhuongtien() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Xử lý vi phạm hành chính lĩnh vực đường bộ",
            tabContent: <Viphamhanhchinh />,
          },
          {
            tabName: "xử lý vi phạm thông qua thiết bị giám sát hành trình",
            tabContent: <Viphamgiatsathanhtrinh />,
          },
        ]}
      />
    </div>
  );
}
